import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SearchBarContextService } from '@core/services/context/search-bar-context.service';

@Component({
  selector: 'mapfre-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, OnDestroy {
  @Input() placeholder = '';
  @Input() set animation(value) {
    this.animate = value !== 'false';
  }
  @Input() subscribeToSearchBarService = false;

  /**
   * You should be bind to only one of those events:
   * @Output searchButton: emits when lens is pressed (Old fashion way)
   * @Output type: emits whenever user types
   */
  @Output() searchButton = new EventEmitter();
  @Output() type = new EventEmitter();

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  animate: boolean;
  textSearched = new FormControl('', Validators.required);
  isTyping = false;
  textSearchedSubscription: Subscription;

  constructor(private searchBarService: SearchBarContextService) {}

  ngOnInit() {
    if (this.subscribeToSearchBarService) {
      this.textSearchedSubscription = this.searchBarService.textSearched$.subscribe(
        (text: string) => {
          this.textSearched.setValue(text);
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.subscribeToSearchBarService && this.textSearchedSubscription !== undefined) {
      this.textSearchedSubscription.unsubscribe();
    }
  }

  onSearchButton() {
    this.searchButton.emit(this.textSearched.value.trim());
    this.isTyping = false;
  }

  onTyping() {
    this.type.emit(this.textSearched.value.trim());
    this.isTyping = true;
  }

  onFocus() {
    if (this.textSearched.value == null) {
      this.isTyping = false;
    } else {
      this.isTyping = true;
    }
  }

  onReset() {
    this.textSearched.reset('');
    this.type.emit('');
    this.isTyping = false;
  }

  onEnterOrSearchKeyPressed() {
    this.searchButton.emit(this.textSearched.value.trim());
    this.type.emit(this.textSearched.value.trim());
    this.isTyping = false;
  }

  focusSearchInput() {
    // Hack: in order to work, focus have to be done after animation is performed, hence this
    // 500ms timeout
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 250);
  }
}
